import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tw-flex tw-flex-col tw-gap-3 tw-rounded-md tw-bg-slate-100 tw-p-4 tw-py-2 tw-text-left" }
const _hoisted_2 = { class: "tw-text-sm tw-text-muted-foreground" }


export default /*#__PURE__*/_defineComponent({
  __name: 'BrandKitGoToSelectPrompt',
  props: {
    message: { default: "Select a brand kit from the Brand Kit section to access your brand's colors and assets within your Look & Feel." },
    buttonText: { default: 'Go to Select Brand Kit' }
  },
  emits: ["goToSelectBrandKit"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.message), 1),
    _createElementVNode("button", {
      type: "button",
      class: "tw-w-fit tw-rounded-md tw-bg-transparent tw-text-xs tw-font-medium tw-text-black tw-underline hover:tw-text-deep-orange-500 focus:tw-outline-none focus:tw-ring-0",
      "data-testid": "go-to-create-brand-kit-button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('goToSelectBrandKit')))
    }, _toDisplayString(_ctx.buttonText), 1)
  ]))
}
}

})